module.exports = __webpack_public_path__ + "img/baoxian.9ac0bcfd.png";